import { createContext } from 'lib/createContext'
import React, { PropsWithChildren, useState } from 'react'
import { BillRate } from '../types'

type Workflow = {
  open: () => void
  close: () => void
  isOpen: boolean
}

type EditBillRateWorkflow = {
  open: (billRate: BillRate) => void
  close: () => void
  isOpen: boolean
  billRate: BillRate | null
}

export type BillRatesWorkflowsContextState = {
  createBillRateFlow: Workflow
  editBillRateFlow: EditBillRateWorkflow
  deleteBillRateFlow: EditBillRateWorkflow
}

const [BillRatesWorkflowsContext, useBillRatesWorkflowsContextValue] =
  createContext<BillRatesWorkflowsContextState>({
    name: 'BillRatesWorkflowsContext',
  })

export const BillRatesWorkflowsProvider = ({ children }: PropsWithChildren) => {
  const [isCreateBillRateFlowOpen, setIsCreateBillRateFlowOpen] =
    useState(false)
  const [isEditBillRateFlowOpen, setIsEditBillRateFlowOpen] = useState(false)
  const [editBillRate, setEditBillRate] = useState<BillRate | null>(null)
  const [isDeleteBillRateFlowOpen, setIsDeleteBillRateFlowOpen] =
    useState(false)
  const [deleteBillRate, setDeleteBillRate] = useState<BillRate | null>(null)

  const value: BillRatesWorkflowsContextState = {
    createBillRateFlow: {
      open: () => setIsCreateBillRateFlowOpen(true),
      close: () => setIsCreateBillRateFlowOpen(false),
      isOpen: isCreateBillRateFlowOpen,
    },
    editBillRateFlow: {
      open: (billRate: BillRate) => {
        setEditBillRate(billRate)
        setIsEditBillRateFlowOpen(true)
      },
      // Keep the selected bill rate so the modal close animation isn't cut short.
      close: () => setIsEditBillRateFlowOpen(false),
      isOpen: isEditBillRateFlowOpen,
      billRate: editBillRate,
    },
    deleteBillRateFlow: {
      open: (billRate: BillRate) => {
        setDeleteBillRate(billRate)
        setIsDeleteBillRateFlowOpen(true)
      },
      // Keep the selected bill rate so the modal close animation isn't cut short.
      close: () => setIsDeleteBillRateFlowOpen(false),
      isOpen: isDeleteBillRateFlowOpen,
      billRate: deleteBillRate,
    },
  }

  return (
    <BillRatesWorkflowsContext.Provider value={value}>
      {children}
    </BillRatesWorkflowsContext.Provider>
  )
}

export { useBillRatesWorkflowsContextValue }
